// Labels for the top Menu action groups (Menu / Item / Section / Discount / AI) and their dialogs.
const TEXT = {
  ar: {
    item: "الأصناف",
    section: "الأقسام",
    discount: "الخصومات",
    itemGroup: "إجراءات الأصناف",
    sectionGroup: "إجراءات الأقسام",
    discountGroup: "إجراءات الخصومات",
    menus: "قوائم الطعام",
    menusGroup: "إدارة قوائم الطعام",
    ai: "الذكاء الاصطناعي",
    aiGroup: "أدوات الذكاء الاصطناعي",
    addItem: "إضافة صنف",
    updateItem: "تعديل صنف",
    copyItem: "نسخ صنف",
    archiveItem: "أرشفة صنف",
    addSection: "إضافة قسم",
    updateSection: "تعديل قسم",
    copySection: "نسخ قسم",
    archiveSection: "أرشفة قسم",
    addDiscount: "إضافة خصم",
    updateDiscount: "تعديل خصم",
    removeDiscount: "إزالة خصم",
    copyDiscount: "نسخ خصم",
    menu: "قائمة الطعام",
    section_: "القسم",
    item_: "الصنف",
    sourceMenu: "قائمة الطعام المصدر",
    sourceSection: "القسم المصدر",
    sourceItem: "الصنف المصدر",
    sourcePricing: "السعر المصدر (به خصم)",
    destinationMenu: "قائمة الطعام الهدف",
    destinationSection: "القسم الهدف",
    source: "المصدر",
    destination: "الوجهة",
    selectMenu: "اختر قائمة الطعام",
    selectSection: "اختر القسم",
    selectItem: "اختر الصنف",
    selectPricing: "اختر السعر",
    loading: "جاري التحميل...",
    noMenus: "لا توجد قوائم طعام قابلة للتعديل لهذا المطعم.",
    noSections: "لا توجد أقسام في قائمة الطعام هذه.",
    noItems: "لا توجد أصناف في هذا القسم.",
    newItemImage: "صورة الصنف (اختياري، 1024 × 700)",
    currentImage: "الصورة الحالية",
    chooseImage: "اختيار صورة",
    replaceImage: "استبدال الصورة",
    imageUploadFailed: "تم حفظ الصنف لكن تعذر رفع الصورة: ",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    copy: "نسخ",
    archive: "أرشفة",
    nothingChanged: "لا توجد تغييرات للحفظ.",
    copyName: "اسم القسم الجديد (اختياري)",
    copyNameHint: "اتركه فارغاً للإبقاء على نفس الاسم.",
    copyItemNote: "النسخة مستقلة بمعرفات جديدة: الأسعار والخصومات والإضافات والصورة تُنسخ، وإخفاء الفروع يُنقل فقط للفروع المرتبطة بقائمة الطعام الهدف.",
    copySectionNote: "يُنسخ القسم مع كل أصنافه الحالية كنسخة مستقلة بمعرفات جديدة.",
    archiveItemBody: "سيُؤرشف الصنف ولن يُحذف، ويمكن استعادته من المحتوى المؤرشف.",
    archiveSectionBody: "سيُؤرشف القسم ولن يُحذف. أصنافه تبقى داخله وتعود معه عند الاستعادة.",
    sectionHasItems: (n) => `يحتوي هذا القسم على ${n} صنف.`,
    sectionEmpty: "هذا القسم لا يحتوي على أصناف.",
    prices: "الأسعار",
    saved: "تم الحفظ",
    itemAdded: "تمت إضافة الصنف",
    itemUpdated: "تم تعديل الصنف",
    itemCopied: "تم نسخ الصنف",
    itemArchived: "تمت أرشفة الصنف",
    sectionAdded: "تمت إضافة القسم",
    sectionUpdated: "تم تعديل القسم",
    sectionCopied: (n) => `تم نسخ القسم مع ${n} صنف`,
    sectionArchived: "تمت أرشفة القسم",
    droppedAdditions: (n) => ` · لم تُنسخ ${n} إضافة غير متاحة`,
    // cross-restaurant copy
    sourceRestaurant: "المطعم المصدر",
    destinationRestaurant: "المطعم الهدف",
    selectRestaurant: "اختر المطعم",
    noMenusInRestaurant: "لا توجد قوائم طعام قابلة للتعديل في هذا المطعم.",
    checkingLinks: "جاري التحقق من الارتباطات الخاصة بالمطعم...",
    crossRestaurantTitle: "نسخ إلى مطعم آخر",
    crossRestaurantBody: (from, to) => `المحتوى والأسعار والخصومات والصور تُنسخ من «${from}» إلى «${to}». إخفاء الفروع لا يُنقل، والإضافات تُربط فقط بإضافات «${to}».`,
    branchOverridesDropped: (n) => `لن يُنقل إخفاء الفروع (${n}) لأن الفروع خاصة بكل مطعم.`,
    noAdditionLinks: "لا توجد إضافات مرتبطة بالمحتوى المنسوخ.",
    additionLinks: "ربط الإضافات في المطعم الهدف",
    additionLinksHint: "اختر إضافة من المطعم الهدف لكل إضافة، أو «بدون ربط». لا تُنشأ إضافات جديدة تلقائياً.",
    doNotLink: "بدون ربط",
    usedByItems: (n) => `في ${n} صنف`,
    unavailableAdditions: (n) => `${n} إضافة غير متاحة في المطعم المصدر ولن تُربط.`,
    skippedLinksSummary: (n) => `${n} ربط إضافة لن يُنسخ لعدم وجود إضافة مقابلة في المطعم الهدف.`,
    crossRestaurantDone: " إلى مطعم آخر",
    linkReasons: {
      same_short_name: "تم العثور على إضافة بنفس الاسم المختصر",
      cloned_from: "نسخة من نفس الإضافة",
      manual: "اختيارك",
      no_destination_match: "لا توجد إضافة مقابلة — لن تُربط",
      skipped_by_user: "لن تُربط",
      unavailable: "غير متاحة",
      inactive: "غير مفعلة",
      same_restaurant: "نفس المطعم",
    },
    discountCrossNote: "يُنسخ نوع الخصم وقيمته فقط، ولا تتغير أسعار الأصناف في المطعم الهدف.",
    // discount dialog
    scope: "النطاق",
    scopeItems: "أصناف محددة",
    scopeSections: "أقسام",
    scopeMenu: "قائمة الطعام كاملة",
    sectionFilter: "القسم",
    allSections: "كل الأقسام",
    items: "الأصناف",
    sections: "الأقسام",
    selectAll: "تحديد الكل",
    clear: "مسح",
    selectedCount: (n) => `${n} محدد`,
    wholeMenuNote: (n) => `سيشمل كل الأصناف الحالية في قائمة الطعام (${n}).`,
    pricingNames: "أسماء الأسعار",
    pricingNamesHint: "من الأسعار الموجودة فعلاً في الأصناف المختارة. لا يُنشأ سعر جديد لصنف لا يملكه.",
    discountType: "نوع الخصم",
    amount: "مبلغ",
    percentage: "نسبة %",
    discountValue: "قيمة الخصم",
    overwrite: "استبدال الخصومات الموجودة",
    matchDiscount: "طبّق على",
    anyDiscount: "كل الأسعار التي عليها خصم",
    onlyDiscount: (label, n) => `فقط الخصم ${label} (${n})`,
    preview: "معاينة",
    previewing: "جاري المعاينة...",
    applyTo: (n) => `تطبيق على ${n} صنف`,
    previewTitle: "معاينة التغيير",
    itemsFound: "الأصناف المشمولة",
    eligible: "سيتغير",
    skipped: "مستثنى",
    currentDiscounts: "الخصومات الحالية",
    newDiscount: "الخصم الجديد",
    noneDiscount: "بدون خصم",
    showSkipped: "عرض المستثنى وسببه",
    showAffected: "عرض الأصناف التي ستتغير",
    previewStale: "تغيرت الاختيارات. اعرض المعاينة من جديد.",
    discountApplied: (n, s) => `تم التطبيق على ${n} صنف${s ? ` · مستثنى ${s}` : ""}`,
    invalidDiscount: "قيمة الخصم غير صحيحة",
    percentMax: "النسبة لا تتجاوز 100",
    reasons: {
      no_pricing_entry: "لا يوجد سعر بهذا الاسم",
      no_discount: "لا يوجد خصم لتعديله أو إزالته",
      already_discounted: "عليه خصم آخر (فعّل الاستبدال)",
      different_discount: "خصمه الحالي مختلف",
      discount_exceeds_price: "الخصم أكبر من السعر",
      unchanged: "نفس الخصم مطبق مسبقاً",
    },
    opTitle: { add: "إضافة خصم", update: "تعديل خصم", remove: "إزالة خصم", copy: "نسخ خصم" },
  },
  en: {
    item: "Item",
    section: "Section",
    discount: "Discount",
    itemGroup: "Item actions",
    sectionGroup: "Section actions",
    discountGroup: "Discount actions",
    menus: "Menu",
    menusGroup: "Menu management",
    ai: "AI",
    aiGroup: "AI tools",
    addItem: "Add Item",
    updateItem: "Update Item",
    copyItem: "Copy Item",
    archiveItem: "Archive Item",
    addSection: "Add Section",
    updateSection: "Update Section",
    copySection: "Copy Section",
    archiveSection: "Archive Section",
    addDiscount: "Add Discount",
    updateDiscount: "Update Discount",
    removeDiscount: "Remove Discount",
    copyDiscount: "Copy Discount",
    menu: "Menu",
    section_: "Section",
    item_: "Item",
    sourceMenu: "Source menu",
    sourceSection: "Source section",
    sourceItem: "Source item",
    sourcePricing: "Source price (with discount)",
    destinationMenu: "Destination menu",
    destinationSection: "Destination section",
    source: "Source",
    destination: "Destination",
    selectMenu: "Select menu",
    selectSection: "Select section",
    selectItem: "Select item",
    selectPricing: "Select price",
    loading: "Loading...",
    noMenus: "This restaurant has no editable menus.",
    noSections: "This menu has no sections.",
    noItems: "This section has no items.",
    newItemImage: "Item image (optional, 1024 × 700)",
    currentImage: "Current image",
    chooseImage: "Choose image",
    replaceImage: "Replace image",
    imageUploadFailed: "The item was saved but the image could not be uploaded: ",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    copy: "Copy",
    archive: "Archive",
    nothingChanged: "Nothing changed.",
    copyName: "New section name (optional)",
    copyNameHint: "Leave empty to keep the same name.",
    copyItemNote: "The copy is independent with new ids: prices, discounts, additions and image are copied; branch hiding is kept only for branches that use the destination menu.",
    copySectionNote: "The section and all of its current items are copied as an independent copy with new ids.",
    archiveItemBody: "The item is archived, not deleted, and can be restored from archived content.",
    archiveSectionBody: "The section is archived, not deleted. Its items stay inside it and come back when it is restored.",
    sectionHasItems: (n) => `This section contains ${n} ${n === 1 ? "item" : "items"}.`,
    sectionEmpty: "This section has no items.",
    prices: "Prices",
    saved: "Saved",
    itemAdded: "Item added",
    itemUpdated: "Item updated",
    itemCopied: "Item copied",
    itemArchived: "Item archived",
    sectionAdded: "Section added",
    sectionUpdated: "Section updated",
    sectionCopied: (n) => `Section copied with ${n} ${n === 1 ? "item" : "items"}`,
    sectionArchived: "Section archived",
    droppedAdditions: (n) => ` · ${n} unavailable addition link(s) not copied`,
    sourceRestaurant: "Source restaurant",
    destinationRestaurant: "Destination restaurant",
    selectRestaurant: "Select restaurant",
    noMenusInRestaurant: "This restaurant has no editable menus.",
    checkingLinks: "Checking restaurant-specific links...",
    crossRestaurantTitle: "Copy to another restaurant",
    crossRestaurantBody: (from, to) => `Content, prices, discounts and images are copied from "${from}" to "${to}". Branch hiding is not carried over, and additions are only linked to additions of "${to}".`,
    branchOverridesDropped: (n) => `Branch hiding (${n}) is not carried over: branches belong to each restaurant.`,
    noAdditionLinks: "The copied content links no additions.",
    additionLinks: "Addition links in the destination restaurant",
    additionLinksHint: "Pick one of the destination restaurant's additions for each, or \"Do not link\". No addition is created automatically.",
    doNotLink: "Do not link",
    usedByItems: (n) => `${n} ${n === 1 ? "item" : "items"}`,
    unavailableAdditions: (n) => `${n} addition(s) are not available in the source restaurant and will not be linked.`,
    skippedLinksSummary: (n) => `${n} addition link(s) will not be copied: no matching addition in the destination restaurant.`,
    crossRestaurantDone: " to another restaurant",
    linkReasons: {
      same_short_name: "Matched by short name",
      cloned_from: "Copy of the same addition",
      manual: "Your choice",
      no_destination_match: "No matching addition — will not be linked",
      skipped_by_user: "Will not be linked",
      unavailable: "Unavailable",
      inactive: "Inactive",
      same_restaurant: "Same restaurant",
    },
    discountCrossNote: "Only the discount type and value are copied; destination prices do not change.",
    scope: "Scope",
    scopeItems: "Specific items",
    scopeSections: "Section(s)",
    scopeMenu: "Entire menu",
    sectionFilter: "Section",
    allSections: "All sections",
    items: "Items",
    sections: "Sections",
    selectAll: "Select all",
    clear: "Clear",
    selectedCount: (n) => `${n} selected`,
    wholeMenuNote: (n) => `Applies to every current item of the menu (${n}).`,
    pricingNames: "Pricing names",
    pricingNamesHint: "Taken from the prices the selected items actually have. No price is created for an item that lacks it.",
    discountType: "Discount type",
    amount: "Amount",
    percentage: "Percentage %",
    discountValue: "Discount value",
    overwrite: "Replace existing discounts",
    matchDiscount: "Apply to",
    anyDiscount: "Every discounted price",
    onlyDiscount: (label, n) => `Only the ${label} discount (${n})`,
    preview: "Preview",
    previewing: "Previewing...",
    applyTo: (n) => `Apply to ${n} ${n === 1 ? "item" : "items"}`,
    previewTitle: "Preview",
    itemsFound: "Items found",
    eligible: "Eligible",
    skipped: "Skipped",
    currentDiscounts: "Current discounts",
    newDiscount: "New discount",
    noneDiscount: "No discount",
    showSkipped: "Show skipped items and why",
    showAffected: "Show items that will change",
    previewStale: "The selection changed. Preview again.",
    discountApplied: (n, s) => `Applied to ${n} ${n === 1 ? "item" : "items"}${s ? ` · ${s} skipped` : ""}`,
    invalidDiscount: "Invalid discount value",
    percentMax: "Percentage cannot exceed 100",
    reasons: {
      no_pricing_entry: "No pricing entry with this name",
      no_discount: "No discount to update or remove",
      already_discounted: "Already has another discount (enable replace)",
      different_discount: "Current discount is different",
      discount_exceeds_price: "Discount is larger than the price",
      unchanged: "Same discount already applied",
    },
    opTitle: { add: "Add Discount", update: "Update Discount", remove: "Remove Discount", copy: "Copy Discount" },
  },
};

export const topActionsText = (lang) => TEXT[lang] || TEXT.ar;
